import React, {useEffect} from 'react';

import FirmwareReleaseNotesArticle from '../../../components/FirmwareReleaseNotes/FirmwareReleaseNotesArticle';
import {PopupMobileFullPage} from '../../../components/Popup';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useFirmwareReleaseNotes from '../../../hooks/firmwareReleaseNotes/useFirmwareReleaseNotes';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import modalService from '../../../services/modalService';

const FirmwareReleaseNotesPopup = ({modalType}) => {
    const localizedStrings = getLocalizedStrings();
    const onClose = () => modalService.hideModal(modalType);
    const {setWasShownFwu} = useFirmwareReleaseNotes();

    useEffect(() => {
        setWasShownFwu();
    }, []);

    return (
        <PopupMobileFullPage
            onClose={onClose}
            closeButtonAriaLabel={localizedStrings[localizationKeys.FIRMWARE_MODAL_VIEW_CLOSE_BUTTON_ARIA_LABEL]}
            isCloseVisible
        >
            <div className='flex justify-center px-8 pb-8 pt-18 md:p-0'>
                <FirmwareReleaseNotesArticle onClick={onClose} onCancel={onClose} />
            </div>
        </PopupMobileFullPage>
    );
};

export default FirmwareReleaseNotesPopup;
